import axios from 'axios'

/**
 * Single Case operations
 */

async function getCaseApi(id) {
  try {
    const response = await axios.get(`/api/case/${id}`)
    return response.data
  } catch (error) {
    console.error('Error getting case.', error);
    throw error
  }
}

async function saveCaseApi(caseRecord) {
  try {
    const response = await axios.post('/api/case', caseRecord)
    return response.data
  } catch (error) {
    console.error('Error saving case.', error);
    throw error
  }
}

async function updateCaseApi(id, caseRecord) {
  try {
    const response = await axios.put(`/api/case/${id}`, caseRecord)
    return response.data
  } catch (error) {
    console.error('Error updating case record.', error);
    throw error
  }
}


/**
 * Bulk Case operations
 */

async function getCasesApi(caseRequest) {
  try {
    const response = await axios.post('/api/cases', caseRequest)
    return response.data
  } catch (error) {
    console.error('Error getting cases.', error);
    throw error
  }
}

async function saveCasesApi(caseRecordList) {
  try {
    const response = await axios.post('/api/cases/bulk', caseRecordList)
    return response.data
  } catch (error) {
    console.error('Error saving cases.', error);
    throw error
  }
}

async function screenCasesApi(ids) {
  try {
    const response = await axios.post("/api/cases/screen", ids)
    return response.data
  } catch (error) {
    console.error('Error saving report comment.', error);
    throw error
  }
}

async function bulkPatchCasesApi(params) {

  try {
    const response = await axios.patch("/api/cases", params)
    return response.data
  } catch (error) {
    console.error('Error patching case records.', error);
    throw error
  }
}

async function downloadCaseCsvApi(params) {
  const url = '/api/reports/csv/cases';

  try {
    await axios
    .post(url, params, {
      responseType: 'blob'
    })
    .then((response) => {
      // Extract filename from Content-Disposition header (fallback to default)
      let filename = 'veriscan-case-report-export.csv';
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/i);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      // Create blob and trigger download
      const blob = new Blob([response.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    })
  } catch (error) {
    console.error('Download failed:', error);
    throw error;
  }
}

export { getCaseApi, saveCaseApi, screenCasesApi, getCasesApi, bulkPatchCasesApi, updateCaseApi, saveCasesApi, downloadCaseCsvApi }